import { AsyncAutocompleteSource } from '@components/v2/form/AsyncAutocomplete/asyncAutocomplete.types';
import LangEnum from '../../../lang/LangEnum';
import { AvailabilityEnum } from '../../products/ProductTypes';
import { CatalogCreationBooleanOptions } from './catalogCreationForm.types';

export const CATALOG_CREATION_NAVIGATION_AVAILABILITIES: AvailabilityEnum[] = [
  AvailabilityEnum.READY_FOR_DELIVERY,
  AvailabilityEnum.FUTURE_STOCK,
  AvailabilityEnum.INFINITE_PRE_ORDER,
  AvailabilityEnum.MATERIAL_PRE_ORDER,
];

export const CATALOG_CREATION_NAVIGATION_DELIVERY_WINDOWS_SOURCE: AsyncAutocompleteSource = {
  url: 'delivery-windows',
  queryField: 'codeOrName',
  order: { name: 'ASC' },
  defaultQuery: { onlyAvailable: true },
};

export const CATALOG_CREATION_RELATED_PRODUCTS_OPTIONS: CatalogCreationBooleanOptions = [
  { value: false, label: LangEnum.CATALOGS_CREATION_MODAL_RELATED_PRODUCTS_ALL },
  { value: true, label: LangEnum.CATALOGS_CREATION_MODAL_RELATED_PRODUCTS_CATALOG },
];
